const workReportMinutesList = ['0', '15', '30', '45'];

export default workReportMinutesList;
